import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { TermsConfig } from '@types';

import { GroupType } from '../constants';

interface GroupInfo {
  frequency: string;
  interval: number;
  name: string;
  groupAmount: number;
  dueDate: string;
  isFeeCategoryEnabled?: boolean;
  feeCategories?: {
    category: string;
    amount: string;
  }[];
  isActive: boolean;
  startDate?: string;
  isImmediatePayment?: boolean;
  isCustomTerm?: boolean;
  monthlyConfig?: {
    day_option: string; // first_day, last_day, custom
    custom_day?: number; // 2 to 28
  };
  weeklyConfig?: {
    day_of_week: string; // monday, tuesday, etc.
  };
  termsList?: TermsConfig[];
  customMembers?: {
    name: string;
    country_code: string;
    mobile: string;
  }[];
}

interface ListParams {
  filter: GroupType;
  search: string;
}

interface GroupState {
  currentGroupInfo: GroupInfo;
  listParams: ListParams;
}

const initialState: GroupState = {
  currentGroupInfo: {
    frequency: '',
    interval: 0,
    name: '',
    groupAmount: 0,
    dueDate: '',
    isFeeCategoryEnabled: false,
    feeCategories: [],
    isActive: false,
    startDate: '',
    isImmediatePayment: false,
    isCustomTerm: false,
    monthlyConfig: {
      day_option: '',
      custom_day: 0
    },
    weeklyConfig: {
      day_of_week: ''
    },
    termsList: []
  },
  listParams: { filter: GroupType.ACTIVE, search: '' }
};

export const groupSlice = createSlice({
  name: 'group',
  initialState,
  reducers: {
    updateGroupInfo: (state, action: PayloadAction<GroupInfo>) => {
      state.currentGroupInfo = action.payload;
    },
    updateListParams: (state, action: PayloadAction<ListParams>) => {
      state.listParams = action.payload;
    },
    resetGroupState: () => initialState
  }
});

export const { updateGroupInfo, updateListParams, resetGroupState } =
  groupSlice.actions;
export default groupSlice.reducer;
